import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AnalyticsService } from '../core/services/analytics.service';
import { ILandingConfig, LandingConfigs, LandingService } from '../core/services/landing.service';
import { SeoService } from '../core/services/seo.service';
import { ToolsService } from '../core/services/tools.service';
import { HelpModalComponent } from '../shared/modals/help-modal/help-modal.component';
import { IntlService } from '../core/services/intl.service';
import { isPlatformBrowser } from '@angular/common';
import { ClientService } from '../core/services/client.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  public landing: ILandingConfig;

  public language;
  public country;
  public host;
  public supportEmail;
  public salesPhone;
  public bsModalRef: BsModalRef;
  public showVideo = false;
  public showMobileNav = false;

  public referralData: any;

  public languageSubscription: Subscription;

  public locationTargetedData = null;
  public promoBannerActive = false;
  public locationOptions = [];

  constructor(
    public toolsService: ToolsService,
    private modalService: BsModalService,
    private landingService: LandingService,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
    private intlService: IntlService,
    private clientService: ClientService,
    @Inject(PLATFORM_ID) protected platformId
  ) {

  }

  ngOnInit() {
    this.language = this.intlService.getCurrentLanguage();
    this.country = this.intlService.getCurrentCountry();
    this.host = this.intlService.getHost();

    this.setPromoBannerActive();

    if (isPlatformBrowser(this.platformId)) {
      const referralCode = localStorage?.getItem('referral');
      if (referralCode) {
        this.clientService.getMerchantByReferral(referralCode).subscribe((res) => {
            this.referralData = res;
        });
      }
    }

    this.locationOptions = [
      { city: 'Málaga', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-malaga.jpg?alt=media', title: '¡Hola Málaga!', code: 'HOLAANDALUCIA' },
      { city: 'Sevilla', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-seville.jpg?alt=media', title: '¡Hola Sevilla!', code: 'HOLAANDALUCIA' },
      { city: 'Córdoba', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-cordoba.jpg?alt=media', title: '¡Hola Córdoba!', code: 'HOLAANDALUCIA' },
      { city: 'Granada', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-granada.jpg?alt=media', title: '¡Hola Granada!', code: 'HOLAANDALUCIA' },
      { city: 'Jerez de la Frontera', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-frontera.jpg?alt=media', title: '¡Hola Jerez de la Frontera!', code: 'HOLAANDALUCIA' },
      { city: 'Vigo', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-vigo.jpg?alt=media', title: '¡Hola Vigo!', code: 'HOLAGALICIA' },
      { city: 'A Coruña', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-coruna.jpg?alt=media', title: '¡Hola A Coruña!', code: 'HOLAGALICIA' },
      { city: 'Ourense', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-ourense.jpg?alt=media', title: '¡Hola Ourense!', code: 'HOLAGALICIA' },
      { city: 'Lugo', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-lugo.jpg?alt=media', title: '¡Hola Lugo!', code: 'HOLAGALICIA' },
      { city: 'Santiago de Compostela', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-compostela.jpg?alt=media', title: '¡Hola Santiago de Compostela!', code: 'HOLAGALICIA' },
      { city: 'Valencia', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-valencia.jpg?alt=media', title: '¡Hola Valencia!', code: 'HOLAVALENCIA' },
      { city: 'Alicante', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-alicante.jpg?alt=media', title: '¡Hola Alicante!', code: 'HOLAVALENCIA' },
      { city: 'Elche', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-elche.jpg?alt=media', title: '¡Hola Elche!', code: 'HOLAVALENCIA' },
      { city: 'Castellón de la Plana', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-plana.jpg?alt=media', title: '¡Hola Castellón de la Plana!', code: 'HOLAVALENCIA' },
      { city: 'Torrevieja', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-torrevieja.jpg?alt=media', title: '¡Hola Torrevieja!', code: 'HOLAVALENCIA' },
      { city: 'Madrid', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-madrid.jpg?alt=media', title: '¡Hola Madrid!', code: 'HOLAMADRID' },
      { city: 'Barcelona', image: 'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fbg-barcelona.jpg?alt=media', title: '¡Hola Barcelona!', code: 'HOLACATALUNA' },
    ];

    if (isPlatformBrowser(this.platformId) && this.language === 'es') {
      this.getVisitorLocation();
    }


    this.getLandingConfig();
    this.languageSubscription = this.intlService.languageChanged().subscribe((lang) => {
      this.language = lang;
      this.getLandingConfig();
      this.setPromoBannerActive();
    });
  }

  setPromoBannerActive() {
    return false;
      // this.promoBannerActive = this.language === 'pt' && this.country === 'pt';
  }

  getVisitorLocation() {
    if (localStorage?.getItem('landing:city')) {
      this.setLocationTargetedData(localStorage.getItem('landing:city'));
    } else {
      this.clientService.getVisitorLocation().subscribe((res) => {
         if (res?.location?.country === 'ES' && res?.location?.city) {
          this.setLocationTargetedData(res?.location?.city); // change city here to override locally
          localStorage?.setItem('landing:city', res?.location?.city);
         } else {
          localStorage?.setItem('landing:city', 'none');
         }
      });
    }
  }

  setLocationTargetedData(city) {
    if (this.referralData) {
      return;
    }
    this.locationTargetedData = this.locationOptions.find((loc) => loc.city === city);
    if (this.locationTargetedData) {
      this.analytics.trackProductAnalyticsEvent('location_targeted', this.locationTargetedData.city);
    }
  }

  getLandingConfig() {
    this.supportEmail = this.intlService.getSupportEmail();
    this.salesPhone = this.intlService.getContactPhone();

    const activeConfig: LandingConfigs = this.activatedRoute.snapshot.data.config || LandingConfigs.GENERAL;
    this.translate.getTranslation(this.translate.currentLang).subscribe((res) => {
      this.landing = this.landingService.getLandingConfig(activeConfig, res);
      this.setMetaTags(this.landing);
    });
  }

  showVideoOverlay() {
    this.showVideo = !this.showVideo;
  }

  showHelpModal() {
    this.bsModalRef = this.modalService.show(HelpModalComponent, { class: 'modal-md' });
  }

  setMetaTags(data: ILandingConfig) {
    const title = 'BUK | ' + data.pageTitle;
    const description = data.pageDescription;
    const image = data.pageOgImage[this.language];
    this.seoService.setMetaTags(title, description, image);
  }

  analyticsEvent(action, category = 'landing') {
    this.analytics.trackEvent(action, category);
  }

  toggleMobileNav() {
    this.showMobileNav = !this.showMobileNav;
  }

}
